export default {
  API_BASE_URL: '',
};



// WEBPACK FOOTER //
// ./src/config/prod.js